export default __webpack_public_path__ + "static/media/logo.a697021f.svg";